module.exports = __webpack_public_path__ + "img/location-error.929b9df1.svg";